import { generatePath } from 'react-router-dom';

interface GenerateRouteParams {
  [key: string]: string | number | undefined;
}

export function createRoute(path: string, params: GenerateRouteParams) {
  return generatePath(path, params);
}
